import * as React from 'react';
import happyIcon from '../../../static/icons/happy.svg';
import neutralIcon from '../../../static/icons/neutral.svg';
import sadIcon from '../../../static/icons/sad.svg';

const feedbackIcons: Record<string, string> = {
    'happy.svg': happyIcon,
    'neutral.svg': neutralIcon,
    'sad.svg': sadIcon
};

class FeedBack extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }
    
    render() {
        let { score, image, message } = this.props;

        return (
            <div className="feedback-modal">
                <div className="feedback-card">
                    <h3 className="feedback-score">{score.toFixed(0) + '% richtig'}</h3>
                    <div className="feedback-circle">
                        <img src={feedbackIcons[image]} />
                    </div>
                    <p className="feedback-card-message">{message}</p>
                </div>
            </div>
        );
    }
}

export default FeedBack;